export const defaultMemoryBoxNumber = 0;
